(function () {
  'use strict';

  var REPLY_PATTERN = /\[reply:(\d+)\]/;

  function initCommentReplies() {
    var comments = document.querySelectorAll(
      '.article-template__comments-comment, #bloggle_comment-layout > div > article'
    );
    if (!comments.length) return;

    var textarea = document.getElementById('CommentForm-body') || document.getElementById('bggle-comment-body');

    // First pass: tag replies with their parent ID and strip the [reply:] marker
    var replies = []; // { element, parentId }

    comments.forEach(function (comment) {
      var commentId = comment.id;
      if (!commentId) return;

      // Search for [reply:ID] in comment content
      var textTarget = null;
      var firstChild = comment.firstElementChild;
      if (firstChild && firstChild.tagName === 'P') {
        textTarget = firstChild;
      } else {
        for (var i = 0; i < comment.childNodes.length; i++) {
          var node = comment.childNodes[i];
          if (node.nodeType === Node.TEXT_NODE && REPLY_PATTERN.test(node.textContent)) {
            textTarget = node;
            break;
          }
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'FOOTER' && REPLY_PATTERN.test(node.textContent)) {
            textTarget = node;
            break;
          }
        }
      }

      if (textTarget) {
        var raw = textTarget.textContent || '';
        var match = raw.match(REPLY_PATTERN);
        if (match) {
          var parentId = match[1];

          // Strip the tag from display
          if (textTarget.nodeType === Node.TEXT_NODE) {
            textTarget.textContent = raw.replace(REPLY_PATTERN, '').trim();
          } else {
            textTarget.innerHTML = textTarget.innerHTML.replace(/\[reply:\d+\]/, '').trim();
            if (!textTarget.textContent.trim() && textTarget.tagName === 'P') {
              textTarget.remove();
            }
          }

          comment.dataset.replyTo = parentId;
          replies.push({ element: comment, parentId: parentId });
        }
      }
    });

    // Second pass: move replies right after their parent comment
    replies.forEach(function (reply) {
      var parentComment = document.getElementById(reply.parentId);

      // Build reply indicator
      var indicator = document.createElement('div');
      indicator.className = 'comment-reply-indicator';

      if (parentComment) {
        var authorEl = parentComment.querySelector('.circle-divider, .bggle--author');
        var authorName = authorEl ? authorEl.textContent.trim() : null;
        indicator.innerHTML = 'En r\u00E9ponse \u00E0 <strong>' + (authorName || '#' + reply.parentId) + '</strong>';

        // Move reply element right after the parent (or after the last existing reply of that parent)
        var insertAfter = parentComment;
        var next = parentComment.nextElementSibling;
        while (next && next.dataset.replyTo === reply.parentId) {
          insertAfter = next;
          next = next.nextElementSibling;
        }
        insertAfter.parentNode.insertBefore(reply.element, insertAfter.nextSibling);
      } else {
        indicator.innerHTML = 'En r\u00E9ponse \u00E0 un commentaire';
      }

      reply.element.insertBefore(indicator, reply.element.firstElementChild);
      reply.element.classList.add('comment--reply');
    });

    // Third pass: add reply buttons (admin only)
    function addReplyButtons() {
      comments.forEach(function (comment) {
        var commentId = comment.id;
        if (!commentId || !textarea) return;
        if (comment.classList.contains('comment--reply')) return;

        var footer = comment.querySelector('footer');
        if (!footer) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'comment-reply-btn';
        btn.textContent = 'R\u00E9pondre';
        btn.setAttribute('aria-label', 'R\u00E9pondre \u00E0 ce commentaire');

        btn.addEventListener('click', function () {
          var tag = '[reply:' + commentId + '] ';
          if (textarea.value.match(REPLY_PATTERN)) {
            textarea.value = textarea.value.replace(REPLY_PATTERN, '').trim();
          }
          textarea.value = tag + textarea.value;
          textarea.focus();
          textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        footer.appendChild(btn);
      });
    }

    // Detect Shopify admin/staff browsing the storefront
    var debugMode = new URLSearchParams(window.location.search).has('reply-admin');
    if (debugMode || (window.Shopify && Shopify.designMode)) {
      addReplyButtons();
    } else {
      // Admin bar loads after page — check once DOM settles
      setTimeout(function () {
        if (document.querySelector('#admin-bar-iframe, #preview-bar-iframe, iframe[src*="admin"], shopify-preview-bar')) {
          addReplyButtons();
        }
      }, 800);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCommentReplies);
  } else {
    initCommentReplies();
  }
})();
